import {FeedingStage} from '@/common/Enum/feedingstage.enum';
import {
    NewPlacement,
    PlacementChicksFeedingProgram
} from '@/common/interface/placement.data.model';
import {SelectedFarmhouseId} from '@/common/interface/selected.id.model';
import {Component, OnInit} from '@angular/core';
import {
    FormArray,
    FormBuilder,
    FormGroup,
    Validators,
    AbstractControl,
    ValidationErrors
} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {resultMemoize} from '@ngrx/store';
import {DisinfectionprogramService} from '@services/disinfectionprogram.service';
import {FarmService} from '@services/farm.service';
import {LitterService} from '@services/litter.service';
import {LoaderService} from '@services/loader.service';
import {PlacementService} from '@services/placement.service';
import {SupplierService} from '@services/supplier.service';
import {VaccineService} from '@services/vaccine.service';
import {ToastrService} from 'ngx-toastr';
import {Observable} from 'rxjs';

@Component({
    selector: 'app-add-placement',
    templateUrl: './add-placement.component.html',
    styleUrl: './add-placement.component.scss'
})
export class AddPlacementComponent implements OnInit {
    placementForm: FormGroup;
    FeedingStage = FeedingStage; // Reference the enum in the template
    farmlist: any = [];
    selectedFarmhouseIds: number[] = [];
    farmhouselist: any = [];
    partitionlist: any = [];
    supplierList: any = [];
    breeds: any = [];
    selectedFarmhouses: Set<number> = new Set();
    birdTypes: any = [];
    disInfections: any = [];
    litters: any = [];
    vaccines: any = [];
    public isAuthLoading = false;
    public isLoading$: Observable<boolean>;
    public errorMessage: string = '';
    public fieldTextType: boolean;
    placementId: number = 0;
    isVisible: boolean;
    selectedIds: number[] = [];
    selectedFarmhouseId: SelectedFarmhouseId[] = [];
    availableFarmhouses: any[];
    userDetail: any;

    private expectedStartSellingDateValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }
        const placementDate = control.parent.get('placementDateTime')?.value;
        const expectedStartDate = control.value;

        if (placementDate && expectedStartDate) {
            const placement = new Date(placementDate);
            const expectedStart = new Date(expectedStartDate);

            placement.setHours(0, 0, 0, 0);
            expectedStart.setHours(0, 0, 0, 0);

            if (expectedStart <= placement) {
                return {expectedStartAfterPlacement: true};
            }
        }
        return null;
    }

    private expectedEndSellingDateValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }
        const expectedStartDate = control.parent.get(
            'expectedStartSellingDate'
        )?.value;
        const expectedEndDate = control.value;

        if (expectedStartDate && expectedEndDate) {
            const expectedStart = new Date(expectedStartDate);
            const expectedEnd = new Date(expectedEndDate);

            expectedStart.setHours(0, 0, 0, 0);
            expectedEnd.setHours(0, 0, 0, 0);

            if (expectedEnd <= expectedStart) {
                return {expectedEndAfterStart: true};
            }
        }
        return null;
    }

    private disinfectionStartDateValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }
        const placementDate = control.parent.get('placementDateTime')?.value;
        const disinfectionStartDate = control.value;

        if (placementDate && disinfectionStartDate) {
            const placement = new Date(placementDate);
            const disinfectionStart = new Date(disinfectionStartDate);

            placement.setHours(0, 0, 0, 0);
            disinfectionStart.setHours(0, 0, 0, 0);

            // Changed: disinfection start date must be BEFORE placement date
            if (disinfectionStart >= placement) {
                return {disinfectionStartBeforePlacement: true};
            }
        }
        return null;
    }

    private disinfectionEndDateValidator(
        control: AbstractControl
    ): ValidationErrors | null {
        if (!control.parent) {
            return null;
        }
        const placementDate = control.parent.get('placementDateTime')?.value;
        const disinfectionStartDate = control.parent.get(
            'disInfectionProgramStartDate'
        )?.value;
        const disinfectionEndDate = control.value;

        if (disinfectionStartDate && disinfectionEndDate) {
            const disinfectionStart = new Date(disinfectionStartDate);
            const disinfectionEnd = new Date(disinfectionEndDate);

            disinfectionStart.setHours(0, 0, 0, 0);
            disinfectionEnd.setHours(0, 0, 0, 0);

            if (disinfectionEnd <= disinfectionStart) {
                return {disinfectionEndAfterStart: true};
            }
        }

        if (placementDate && disinfectionEndDate) {
            const placement = new Date(placementDate);
            const disinfectionEnd = new Date(disinfectionEndDate);

            placement.setHours(0, 0, 0, 0);
            disinfectionEnd.setHours(0, 0, 0, 0);

            if (disinfectionEnd >= placement) {
                return {disinfectionEndBeforePlacement: true};
            }
        }

        return null;
    }

    constructor(
        private fb: FormBuilder,
        private placementService: PlacementService,
        private farmService: FarmService,
        private supplierService: SupplierService,
        private disInfectionService: DisinfectionprogramService,
        private vaccineService: VaccineService,
        private litterService: LitterService,
        private toastr: ToastrService,
        private loaderService: LoaderService,
        private route: ActivatedRoute, // Add this
        private router: Router
    ) {
        this.isLoading$ = this.loaderService.isLoading$;
    }

    ngOnInit(): void {
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        this.initializeForm();
        this.placementForm.get('qty').disable();
        this.userDetail = JSON.parse(localStorage.getItem('UserDetail'));
        const placementId = this.route.snapshot.paramMap.get('id');
        if (!!placementId) {
            this.isVisible = false;
            this.loadPlacementData(+placementId);
        } else {
            this.availableFarmhouses = [...this.farmhouselist];
            this.isVisible = true;
            this.getFarmList(this.userDetail.id);
            this.getSupplierList();
            this.getAllDisinfections();
            this.getAllLitters();
            this.getAllVaccines();
            this.getAllBreed();
            this.addHousePartitions(1);
            // this.placementChicksFeedingProgram.clear();
        }
        // this.placementForm.get('id')?.valueChanges.subscribe(value => {
        //   this.isVisible = value !== 0; // Update visibility based on form control value
        // });
    }

    createHousePartitionGroup(): FormGroup {
        return this.fb.group({
            id: [0],
            placementId: [0], // This will be set when submitting the form
            farmhouseId: ['', Validators.required],
            partitionIds: [[], Validators.required],
            houseChicksQty: ['', [Validators.required, Validators.min(0)]]
        });
    }

    createFeedingProgramGroup(stageId: FeedingStage): FormGroup {
        const isPreStarter = stageId === FeedingStage.PreStarter; // Check if it's PreStarter
        return this.fb.group({
            id: [0], // Initialize with 0 or null
            placementId: [0], // This will be set when submitting the form
            stageId: [stageId, Validators.required],
            agefrom: [
                isPreStarter ? null : '',
                isPreStarter ? [] : [Validators.required, Validators.min(0)]
            ],
            ageTo: [
                isPreStarter ? null : '',
                isPreStarter ? [] : [Validators.required, Validators.min(0)]
            ],
            chicksQty: [
                isPreStarter ? null : '',
                isPreStarter ? [] : [Validators.required, Validators.min(0)]
            ]
        });
    }
    initializeForm() {
        this.placementForm = this.fb.group({
            id: [0],
            flockNo: ['', Validators.required],
            farmId: ['', Validators.required],
            userId: this.userDetail.id,
            supplierId: ['', Validators.required],
            placementDateTime: ['', Validators.required],
            expectedStartSellingDate: [
                '',
                [
                    Validators.required,
                    this.expectedStartSellingDateValidator.bind(this)
                ]
            ],
            expectedEndSellingDate: [
                '',
                [
                    Validators.required,
                    this.expectedEndSellingDateValidator.bind(this)
                ]
            ],
            placementHousePartition: this.fb.array([]),
            breedId: ['', Validators.required],
            targetWeight: ['', [Validators.required, Validators.min(0)]],
            qty: ['', [Validators.required, Validators.min(0)]],
            parentStockAge: null,
            disInfectionProgramId: ['', Validators.required],
            vaccineId: ['', Validators.required],
            litterTypeId: ['', Validators.required],
            placementChicksFeedingProgram: this.fb.array([
                this.createFeedingProgramGroup(FeedingStage.PreStarter),
                this.createFeedingProgramGroup(FeedingStage.Starter),
                this.createFeedingProgramGroup(FeedingStage.Grower),
                this.createFeedingProgramGroup(FeedingStage.Finisher)
            ]),
            disInfectionProgramStartDate: [
                '',
                [
                    Validators.required,
                    this.disinfectionStartDateValidator.bind(this)
                ]
            ],
            disInfectionProgramEndDate: [
                '',
                [
                    Validators.required,
                    this.disinfectionEndDateValidator.bind(this)
                ]
            ],
            venhicleTempeature: ['', Validators.required],
            venhicleHumidity: ['', Validators.required],
            stoppingTime: ['', Validators.required],
            chicksTripTime: ['', Validators.required]
        });

        this.placementForm
            .get('placementDateTime')
            ?.valueChanges.subscribe(() => {
                this.placementForm
                    .get('expectedStartSellingDate')
                    ?.updateValueAndValidity({emitEvent: false});
                this.placementForm
                    .get('disInfectionProgramStartDate')
                    ?.updateValueAndValidity({emitEvent: false});
            });

        this.placementForm
            .get('expectedStartSellingDate')
            ?.valueChanges.subscribe(() => {
                this.placementForm
                    .get('expectedEndSellingDate')
                    ?.updateValueAndValidity({emitEvent: false});
            });

        this.placementForm
            .get('disInfectionProgramStartDate')
            ?.valueChanges.subscribe(() => {
                this.placementForm
                    .get('disInfectionProgramEndDate')
                    ?.updateValueAndValidity({emitEvent: false});
            });

        this.placementHousePartition.valueChanges.subscribe(() => {
            this.calculateTotalQty();
        });
    }

    calculateTotalQty() {
        const total = this.placementHousePartition.controls.reduce(
            (sum, group) => {
                const qty = group.get('houseChicksQty')?.value || 0;
                return sum + (isNaN(qty) ? 0 : Number(qty));
            },
            0
        );
        this.placementForm.get('qty')?.setValue(total);
    }
    loadPlacementData(placementId: number) {
        this.getFarmList(this.userDetail.id);
        this.getSupplierList();
        this.getAllDisinfections();
        this.getAllVaccines();
        this.getAllLitters();
        this.getAllBreed();
        this.placementService
            .getPlacementById(placementId)
            .subscribe((placement: NewPlacement) => {
                // Patch the basic placement data
                this.placementForm.patchValue({
                    id: placement.id,
                    flockNo: placement.flockNo,
                    farmId: placement.farmId,
                    supplierId: placement.supplierId,
                    placementDateTime: placement.placementDateTime,
                    expectedStartSellingDate: this.formatDate(
                        new Date(placement.expectedStartSellingDate)
                    ),
                    expectedEndSellingDate: this.formatDate(
                        new Date(placement.expectedEndSellingDate)
                    ),
                    breedId: placement.breedId,
                    targetWeight: placement.targetWeight,
                    qty: placement.qty,
                    parentStockAge: placement.parentStockAge,
                    disInfectionProgramId: placement.disInfectionProgramId,
                    vaccineId: placement.vaccineId,
                    litterTypeId: placement.litterTypeId,
                    venhicleTempeature: placement.venhicleTempeature,
                    venhicleHumidity: placement.venhicleHumidity,
                    stoppingTime: placement.stoppingTime,
                    chicksTripTime: placement.chicksTripTime
                });

                // Handle placementHousePartition array
                const housePartitionsArray = this.placementHousePartition;
                while (housePartitionsArray.length) {
                    housePartitionsArray.removeAt(0);
                }
                placement.placementHousePartition.forEach(
                    (partition, index) => {
                        const group = this.createHousePartitionGroup();
                        group.patchValue(partition);
                        housePartitionsArray.push(group);
                        this.getFarmHousePartitionList(
                            partition.farmhouseId,
                            index
                        );
                    }
                );

                // Handle placementChicksFeedingProgram array
                const feedingProgramsArray = this.placementChicksFeedingProgram;
                while (feedingProgramsArray.length) {
                    feedingProgramsArray.removeAt(0);
                }
                placement.placementChicksFeedingProgram.forEach((program) => {
                    const group =
                        this.createFeedingProgramGroupFromData(program);
                    feedingProgramsArray.push(group);
                });

                this.calculateTotalQty();

                // Update other fields or methods if needed
                this.getFarmHouseList(placement.farmId);
            });
    }
    formatDate(date: Date): string {
        const d = new Date(date);
        const month = ('0' + (d.getMonth() + 1)).slice(-2);
        const day = ('0' + d.getDate()).slice(-2);
        const year = d.getFullYear();
        return `${year}-${month}-${day}`;
    }
    createFeedingProgramGroupFromData(data: any): FormGroup {
        return this.fb.group({
            id: [data.id],
            placementId: [data.placementId],
            stageId: [data.stageId, Validators.required],
            agefrom: [data.agefrom, [Validators.required, Validators.min(0)]],
            ageTo: [data.ageTo, [Validators.required, Validators.min(0)]],
            chicksQty: [
                data.chicksQty,
                [Validators.required, Validators.min(0)]
            ]
        });
    }

    get placementChicksFeedingProgram() {
        return this.placementForm.get(
            'placementChicksFeedingProgram'
        ) as FormArray;
    }

    get placementHousePartition(): FormArray {
        return this.placementForm.get('placementHousePartition') as FormArray;
    }

    addHousePartition(): void {
        this.placementHousePartition.push(this.createHousePartitionGroup());
        this.partitionlist.push([]);
    }

    addHousePartitions(count: number): void {
        for (let i = 0; i < count; i++) {
            this.addHousePartition();
        }
    }

    removeHousePartition(index: number): void {
        if (this.placementHousePartition.length > 1) {
            // Get the partition group being removed
            const partitionGroup = this.placementHousePartition.at(index);
            const farmhouseId = partitionGroup.get('farmhouseId')?.value;

            // Remove the farmhouse from selectedFarmhouses if it was selected
            if (farmhouseId) {
                this.selectedFarmhouses.delete(farmhouseId);
            }

            // Remove the form group from the array
            this.placementHousePartition.removeAt(index);

            // Remove the corresponding partition list
            this.partitionlist.splice(index, 1);
        }
    }

    isControlInvalid(controlName: string): boolean {
        const control = this.placementForm.get(controlName);
        return control?.invalid && (control.touched || control.dirty);
    }
    isControlInvalidFeed(controlName: string, formGroup: FormGroup): boolean {
        const control = formGroup.get(controlName);
        return control?.invalid && (control.touched || control.dirty);
    }

    getDateErrorMessage(controlName: string): string {
        const control = this.placementForm.get(controlName);
        if (control?.hasError('required')) {
            return 'This field is required';
        }
        if (
            controlName === 'expectedStartSellingDate' &&
            control?.hasError('expectedStartAfterPlacement')
        ) {
            return 'Expected start selling date must be after placement date';
        }
        if (
            controlName === 'expectedEndSellingDate' &&
            control?.hasError('expectedEndAfterStart')
        ) {
            return 'Expected end selling date must be after expected start selling date';
        }
        return '';
    }

    private markFormGroupTouched(formGroup: FormGroup | FormArray) {
        Object.values(formGroup.controls).forEach((control) => {
            if (control instanceof FormGroup || control instanceof FormArray) {
                this.markFormGroupTouched(control);
            } else {
                control.markAsTouched();
            }
        });
    }
    onSubmit() {
        this.markFormGroupTouched(this.placementForm);

        if (this.placementForm.valid) {
            const formValue = this.placementForm.getRawValue();

            // Extract the PlacementChicksFeedingProgram from form value
            const feedingPrograms: PlacementChicksFeedingProgram[] =
                formValue.placementChicksFeedingProgram.map((item: any) => ({
                    id: item.id,
                    placementId: formValue.id,
                    stageId: item.stageId,
                    agefrom: item.agefrom,
                    ageTo: item.ageTo,
                    chicksQty: item.chicksQty
                }));

            if (formValue.id) {
                const updateModel = {
                    id: formValue.id, // Placement ID
                    placementChicksFeedingProgram: feedingPrograms
                };
                this.bypassPartitionValidators();
                this.placementService
                    .updateChicksFeedingProgram(updateModel)
                    .subscribe({
                        next: (response: any) => {
                            setTimeout(() => {
                                this.isAuthLoading = false;
                                this.loaderService.hideLoader();
                                this.toastr.success(
                                    'Placement Feeding Program Updated'
                                );
                                this.router.navigate(['/placement']);
                            }, 2000);
                        },
                        error: (error) => {
                            setTimeout(() => {
                                this.isAuthLoading = false;
                                this.loaderService.hideLoader();
                                this.toastr.error(
                                    'Error Updating Placement Feeding Program'
                                );
                            }, 2000);
                        }
                    });
            } else {
                const newPlacement: NewPlacement = {
                    ...formValue,
                    placementDateTime: new Date(formValue.placementDateTime),
                    expectedStartSellingDate: new Date(
                        formValue.expectedStartSellingDate
                    ),
                    expectedEndSellingDate: new Date(
                        formValue.expectedEndSellingDate
                    ),
                    disInfectionProgramStartDate: new Date(
                        formValue.disInfectionProgramStartDate
                    ).toISOString(),
                    disInfectionProgramEndDate: new Date(
                        formValue.disInfectionProgramEndDate
                    ).toISOString(),
                    chicksTripTime: new Date(formValue.chicksTripTime),
                    placementHousePartition:
                        formValue.placementHousePartition.map((item: any) => ({
                            ...item,
                            placementId: formValue.id // Assuming you want to set placementId here
                        })),
                    placementChicksFeedingProgram:
                        formValue.placementChicksFeedingProgram.map(
                            (item: any) => ({
                                ...item,
                                placementId: formValue.id, // Set placementId here if needed
                                agefrom:
                                    item.agefrom === null ? 0 : item.agefrom, // Convert null or empty string to 0
                                ageTo: item.ageTo === null ? 0 : item.ageTo, // Convert null or empty string to 0
                                chicksQty:
                                    item.chicksQty === null ? 0 : item.chicksQty // Convert null or empty string to 0
                            })
                        ),
                    parentStockAge:
                        formValue.parentStockAge === null
                            ? 0
                            : formValue.parentStockAge //parent stock optional we sent 0 value if null
                };
                this.placementService.addPlacement(newPlacement).subscribe({
                    next: (response: any) => {
                        this.isAuthLoading = false;
                        this.loaderService.hideLoader();
                        this.toastr.success('Placement Added');
                        this.router.navigate(['/placement']);
                    },
                    error: (error) => {
                        setTimeout(() => {
                            this.isAuthLoading = false;
                            this.loaderService.hideLoader();
                        }, 2000);
                        this.toastr.error('Placement Not Added');
                    }
                });
            }
        } else {
            this.isAuthLoading = false;
            this.loaderService.hideLoader();
            this.toastr.error('Form is not valid');
        }
    }
    bypassPartitionValidators() {
        this.placementHousePartition.controls.forEach((group) => {
            group.get('farmhouseId')?.clearValidators();
            group.get('partitionId')?.clearValidators();
            group.get('farmhouseId')?.updateValueAndValidity();
            group.get('partitionId')?.updateValueAndValidity();
        });
    }

    onFarmChange(farmId: number): void {
        this.placementHousePartition.controls.forEach((group) => {
            group.get('farmhouseId')?.reset(''); // Reset the farmhouseId
            group.get('partitionId')?.reset(''); // Reset the partitionId
        });

        // Clear the partition lists
        this.farmhouselist = [];
        this.partitionlist = [];
        this.getFarmHouseList(farmId);
    }
    onFarmHouseChange(farmHouseId: number, index: number) {
        const partitionGroup = this.placementHousePartition.at(index);

        // Get all selected farmhouses from the form
        const currentSelections = this.placementHousePartition.controls.map(
            (group, i) => (i !== index ? group.get('farmhouseId')?.value : null)
        );

        if (currentSelections.includes(farmHouseId)) {
            this.toastr.error('This farmhouse is already selected!', 'error');
            partitionGroup.get('farmhouseId').setValue('');
            partitionGroup.get('partitionIds').setValue([]);
            partitionGroup.get('houseChicksQty').setValue(0);
            return;
        }

        this.getFarmHousePartitionList(farmHouseId, index);
    }

    getSupplierList() {
        this.supplierService.getSupplierList().subscribe((result) => {
            this.supplierList = result;
        });
    }
    getAllBreed() {
        this.supplierService.getBreedList().subscribe((result) => {
            this.breeds = result;
        });
    }
    getAllBirdType() {
        this.supplierService.getBirdTypeList().subscribe((result) => {
            this.birdTypes = result;
        });
    }
    getAllDisinfections() {
        this.disInfectionService.getDisinfectionList().subscribe((result) => {
            this.disInfections = result;
        });
    }
    getAllLitters() {
        this.litterService.getLitterList().subscribe((result) => {
            this.litters = result;
        });
    }
    getAllVaccines() {
        this.vaccineService.getVaccinationList().subscribe((result) => {
            this.vaccines = result;
        });
    }
    getFarmList(userId: number) {
        this.farmService.getFarmList(userId).subscribe((result) => {
            this.farmlist = result;
        });
    }
    getFarmHouseList(farmId) {
        this.farmService.getFarmHouseList(farmId).subscribe((result) => {
            this.farmhouselist = result;
            this.availableFarmhouses = [...this.farmhouselist];
        });
    }

    getFarmHousePartitionList(farmHouseId: number, index: number): void {
        this.farmService
            .getFarmHousePartitionList(farmHouseId)
            .subscribe((result) => {
                this.partitionlist[index] = result; // Update the partition list for the specific row
                const currentPartitionControl =
                    this.placementHousePartition.at(index);
                const currentPartitionId =
                    currentPartitionControl.get('partitionId')?.value;
                if (currentPartitionId) {
                    // Ensure the partition dropdown reflects the existing selection
                    const partitionControl = this.partitionlist[index].find(
                        (partition) => partition.id === currentPartitionId
                    );
                    if (partitionControl) {
                        currentPartitionControl
                            .get('partitionId')
                            ?.setValue(partitionControl.id);
                    }
                }
            });
    }
}
